import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { INSTAGRAM_URL } from "../constants";
import Button from "./Button";
import "./PagePlaceholder.css";

/**
 * Simple "coming soon" page shell shared by routes that don't have real
 * content yet (Catering, ...). `i18nKey` points at the
 * {title, comingSoon, cta, back} group in translations.js.
 */
function PagePlaceholder({ i18nKey }) {
  const { t } = useLanguage();

  return (
    <main className="PagePlaceholder">
      <h1 className="PagePlaceholder-title">{t(`${i18nKey}.title`)}</h1>
      <p className="PagePlaceholder-copy">{t(`${i18nKey}.comingSoon`)}</p>
      <div className="PagePlaceholder-actions">
        <Button href={INSTAGRAM_URL}>{t(`${i18nKey}.cta`)}</Button>
        <Link to="/" className="Button Button--outline">
          {t(`${i18nKey}.back`)}
        </Link>
      </div>
    </main>
  );
}

export default PagePlaceholder;
